export enum Conference {
    AFC,
    NFC
}